import React from "react";
import { StyledAlert } from "./styles";
import { Snackbar } from "@mui/material";
import { TOAST_TIMER } from "../../utils/constants";

export const Alert = ({ message, type,onToastClose=()=>{} }) => {
  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    onToastClose();
  };
  return (
    <Snackbar
      open={true}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={TOAST_TIMER}
      sx={{ minWidth: "60%" }}
    >
      <StyledAlert
        className="tma_alert"
        onClose={handleClose}
        severity={type}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </StyledAlert>
    </Snackbar>
  );
};
